import { Row, Col, Form, Select, Checkbox } from 'antd';
import LongtailFreeCancellationPeriod from '~components/longtail-cancellation-policy';
import React, { useEffect, useRef, useState } from 'react';
import {
  cancellationPeriodTypeOptions,
  cancellationPeriodTypeValue,
} from '~constants/property-field-options';
import CalendarDays from 'common/components/calendarDays';

const FormItem = Form.Item;
function CancellationBlock({ form, t, mergedProperty }) {
  const { getFieldDecorator, setFields } = form;
  const isBeforeMoveIn =
    mergedProperty.cancellationPeriodType === cancellationPeriodTypeValue.BEFORE_MOVE_IN;
  const isAfterBookingConfirmed =
    mergedProperty.cancellationPeriodType === cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED;
  const cancellationPeriodRef = useRef(null);
  const [cancellationDays, setCancellationDays] = useState(mergedProperty.cancellationPeriodValue);
  const [cancellationType, setCancellationType] = useState(mergedProperty.cancellationPeriodType);
  const [initDays, setInitDays] = useState(false);
  const [initType, setInitType] = useState(false);
  const [cancellationDaysDisabled, setCancellationDaysDisabled] = useState(
    !isBeforeMoveIn && !isAfterBookingConfirmed,
  );
  const [minDay, setMinDay] = useState(isBeforeMoveIn || isAfterBookingConfirmed ? 1 : 0);
  const [forceUpdate, setForceUpdate] = useState(false);

  const handleTypeChange = value => {
    setCancellationType(value);
    if (value === cancellationPeriodTypeValue.NON_REFUNDABLE) {
      setCancellationDays(null);
      setCancellationDaysDisabled(true);
      setMinDay(0);
    }
    if (value === cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY) {
      setCancellationDays(0);
      setCancellationDaysDisabled(true);
      setMinDay(0);
    }
    if (value === cancellationPeriodTypeValue.BEFORE_MOVE_IN) {
      const days = mergedProperty.cancellationPeriodValue || 1;
      setCancellationDays(days);
      setCancellationDaysDisabled(false);
      setMinDay(1);
      setForceUpdate(prev => !prev);
    }
    if (value === cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED) {
      const days = mergedProperty.cancellationPeriodValue || 1;
      setCancellationDays(days);
      setCancellationDaysDisabled(false);
      setMinDay(1);
      setForceUpdate(prev => !prev);
    }
  };

  const handleDayChange = value => {
    setCancellationDays(value);
  };

  useEffect(() => {
    if (!initType) {
      setInitType(true);
      return;
    }

    setFields({ cancellationPeriodType: { value: cancellationType, touched: true } });
  }, [cancellationType]);

  useEffect(() => {
    if (!initDays) {
      setInitDays(true);
      return;
    }

    setFields({ cancellationPeriodValue: { value: cancellationDays, touched: true } });
  }, [cancellationDays, forceUpdate]);

  return (
    <>
      <p className="property-detail__subtitle">Cancellation Policy</p>
      <Row gutter={24}>
        <Col span={12} className="cancellation-period">
          <FormItem
            label={t('cms.properties.edit.detail.cancellation_period')}
            colon={false}
            className="cancellation-period-type"
          >
            <div ref={cancellationPeriodRef}>
              {getFieldDecorator('cancellationPeriodType', {
                initialValue: mergedProperty.cancellationPeriodType,
                trigger: 'onChange',
              })(
                <Select
                  placeholder={t('cms.properties.edit.detail.cancellation_period.placeholder')}
                  getPopupContainer={() => cancellationPeriodRef.current}
                  onChange={handleTypeChange}
                >
                  <For each="item" of={cancellationPeriodTypeOptions}>
                    <Select.Option value={item.value} key={item.value}>
                      {t(item.text)}
                    </Select.Option>
                  </For>
                </Select>,
              )}
            </div>
          </FormItem>
          <FormItem colon={false} className="cancellation-period-days">
            {getFieldDecorator('cancellationPeriodValue', {
              initialValue: mergedProperty.cancellationPeriodValue,
              trigger: 'onChange',
            })(
              <CalendarDays
                t={t}
                onChange={handleDayChange}
                disabled={cancellationDaysDisabled}
                min={minDay}
              />,
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <div className="property-detail__student-booking-guarantee">
            <FormItem
              label={t(
                'cms:cms.properties.edit.detail.cancelation_policy.student_booking_guarantee',
              )}
              colon={false}
            >
              <div className="property-detail__checkbox-wrap">
                {getFieldDecorator('noVisaNoPay', {
                  valuePropName: 'checked',
                  initialValue: mergedProperty.noVisaNoPay,
                  trigger: 'onChange',
                  validateTrigger: 'onBlur',
                })(
                  <Checkbox className="property-detail__cancel-checkbox">
                    {t('cms.properties.edit.detail.cancelation_policy.no_visa_no_pay')}
                  </Checkbox>,
                )}
                {getFieldDecorator('noPlaceNoPay', {
                  valuePropName: 'checked',
                  initialValue: mergedProperty.noPlaceNoPay,
                  trigger: 'onChange',
                  validateTrigger: 'onBlur',
                })(
                  <Checkbox className="property-detail__cancel-checkbox">
                    {t('cms.properties.edit.detail.cancelation_policy.no_place_no_pay')}
                  </Checkbox>,
                )}
              </div>
            </FormItem>
          </div>
        </Col>
      </Row>
      <Row gutter={24}>
        {cancellationType && (
          <LongtailFreeCancellationPeriod t={t} type={cancellationType} value={cancellationDays} />
        )}
      </Row>
    </>
  );
}

export default CancellationBlock;
